/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Mfa_OkInputs */

const fr_account_audit_mfa_ok = /** @type {(inputs: Account_Audit_Mfa_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double authentification activée`)
};

/**

* @param {Account_Audit_Mfa_OkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_mfa_ok = /** @type {((inputs?: Account_Audit_Mfa_OkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Mfa_OkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_mfa_ok(inputs)
});